import { define, html } from "hybrids";

interface VBroadcastPeopleHeader {}

export default define<VBroadcastPeopleHeader>({
  tag: "v-broadcast-people-header",
  render: () => html`<v-ui-text color="text-secondary"
    ><slot></slot
  ></v-ui-text>`.css`
    :host {
      display: block;
    }

    v-ui-text {
      font-size: 13px;
    }
  `,
});
